import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { WarehouseService } from '../_services';
import * as WarehouseActions from '../_actions/warehouse';

@Injectable({
  providedIn: 'root',
})
export class WarehouseEffects {
  loadWarehouses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehouseActions.loadWarehouses),
      mergeMap(() =>
        this.warehouseService.getWarehouses().pipe(
          map((warehouses) => WarehouseActions.loadWarehousesSuccess({ warehouses })),
          catchError((error) => of(WarehouseActions.loadWarehousesFailure({ error })))
        )
      )
    )
  );

  addWarehouse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehouseActions.addWarehouse),
      mergeMap(({ warehouse }) =>
        this.warehouseService.saveWarehouse(warehouse).pipe(
          map((savedWarehouse) =>
            WarehouseActions.addWarehouseSuccess({ warehouse: savedWarehouse })
          ),
          catchError((error) => of(WarehouseActions.addWarehouseFailure({ error })))
        )
      )
    )
  );

  updateWarehouse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehouseActions.updateWarehouse),
      mergeMap(({ warehouse }) =>
        this.warehouseService.saveWarehouse(warehouse).pipe(
          map((updatedWarehouse) =>
            WarehouseActions.updateWarehouseSuccess({ warehouse: updatedWarehouse })
          ),
          catchError((error) => of(WarehouseActions.updateWarehouseFailure({ error })))
        )
      )
    )
  );

  deleteWarehouse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehouseActions.deleteWarehouse),
      mergeMap(({ id }) =>
        this.warehouseService.deleteWarehouse(id).pipe(
          map(() => WarehouseActions.deleteWarehouseSuccess({ id })),
          catchError((error) => of(WarehouseActions.deleteWarehouseFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private warehouseService: WarehouseService
  ) {}
}
